class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    typeof(removeDiscount)==='function' && removeDiscount();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      // ✂️ REMOVED: this.open() - Cart drawer will NOT auto-open after adding items
      // Cart will only open when user clicks the cart icon
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// Enhanced Cross-sell functionality JavaScript with proper initialization
let crossSellInitialized = false;

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  initializeCrossSellFunctionality();
  
  // Also initialize when cart drawer is opened
  observeCartDrawer();
});

// Observe cart drawer for changes
function observeCartDrawer() {
  // Watch for cart drawer visibility changes
  const cartDrawer = document.querySelector('cart-drawer, #CartDrawer');
  if (cartDrawer) {
    // Use MutationObserver to watch for changes
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          // Delay initialization to ensure DOM is updated
          setTimeout(() => {
            initializeCrossSellFunctionality();
          }, 100);
        }
      });
    });
    
    observer.observe(cartDrawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }
  
  // Also listen for custom cart events
  document.addEventListener('cart:updated', function() {
    setTimeout(() => {
      initializeCrossSellFunctionality();
    }, 200);
  });
  
  // Listen for cart drawer specific events
  document.addEventListener('cart:items-changed', function() {
    setTimeout(() => {
      initializeCrossSellFunctionality();
    }, 200);
  });
}

function initializeCrossSellFunctionality() {
  // Find all cross-sell items
  const crossSellWrappers = document.querySelectorAll('.crossell-item-wrapper');
  
  if (crossSellWrappers.length === 0) {
    return; // No cross-sell items found
  }
  
  console.log('Initializing cross-sell functionality for', crossSellWrappers.length, 'items');
  
  crossSellWrappers.forEach((wrapper, index) => {
    // Skip if already initialized
    if (wrapper.hasAttribute('data-crossell-initialized')) {
      return;
    }
    
    const variantList = wrapper.querySelector('.variant_list');
    const addToCartBtn = wrapper.querySelector('.add-to-cart');
    const priceWrapper = wrapper.querySelector('.price_wrapper');
    
    if (!variantList || !addToCartBtn) {
      console.warn('Missing elements in cross-sell item', index);
      return;
    }
    
    try {
      const variantsData = JSON.parse(variantList.dataset.variants || '[]');
      let selectedOptions = {};
      let selectedVariant = null;
      
      // Get current cart items for checking availability
      const cartItems = getCurrentCartItems();
      
      // Initialize with the pre-selected variant
      const crossellId = wrapper.querySelector('[crossell-addon-id]')?.getAttribute('crossell-addon-id');
      if (crossellId) {
        selectedVariant = variantsData.find(v => v.id == parseInt(crossellId));
        if (selectedVariant) {
          selectedOptions = buildSelectedOptions(selectedVariant);
          updateSelectedOptions(wrapper, selectedOptions);
          updateAddToCartButton(addToCartBtn, selectedVariant, cartItems);
        }
      }
      
      // Remove existing event listeners to prevent duplicates
      wrapper.querySelectorAll('.option_value').forEach(optionEl => {
        // Clone node to remove all event listeners
        const newOptionEl = optionEl.cloneNode(true);
        optionEl.parentNode.replaceChild(newOptionEl, optionEl);
      });
      
      // Add fresh event listeners
      wrapper.querySelectorAll('.option_value').forEach(optionEl => {
        // Make sure element is clickable
        optionEl.style.pointerEvents = 'auto';
        optionEl.style.cursor = 'pointer';
        
        // Add click handler
        optionEl.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          console.log('Option clicked:', this.dataset.value);
          
          handleOptionSelection(this, wrapper, variantsData, cartItems);
        });
        
        // Add keyboard support
        optionEl.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            handleOptionSelection(this, wrapper, variantsData, cartItems);
          }
        });
        
        // Make focusable
        if (!optionEl.hasAttribute('tabindex')) {
          optionEl.setAttribute('tabindex', '0');
        }
        
        // Add hover effects
        optionEl.addEventListener('mouseenter', function() {
          this.style.transform = 'translateY(-1px)';
          this.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
        });
        
        optionEl.addEventListener('mouseleave', function() {
          if (!this.classList.contains('selected')) {
            this.style.transform = '';
            this.style.boxShadow = '';
          }
        });
      });
      
      // Handle add to cart button
      const newAddToCartBtn = addToCartBtn.cloneNode(true);
      addToCartBtn.parentNode.replaceChild(newAddToCartBtn, addToCartBtn);
      
      newAddToCartBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        handleAddToCart(this, cartItems);
      });
      
      // Mark as initialized
      wrapper.setAttribute('data-crossell-initialized', 'true');
      
      console.log('Cross-sell item', index, 'initialized successfully');
      
    } catch (error) {
      console.error('Error initializing cross-sell item', index, ':', error);
    }
  });
  
  crossSellInitialized = true;
}

function getCurrentCartItems() {
  const cartItems = [];
  document.querySelectorAll('[data-quantity-variant-id]').forEach(item => {
    const variantId = parseInt(item.dataset.quantityVariantId);
    if (variantId) cartItems.push(variantId);
  });
  console.log('Current cart items:', cartItems);
  return cartItems;
}

function buildSelectedOptions(variant) {
  return {
    1: variant.option1,
    2: variant.option2,
    3: variant.option3
  };
}

function handleOptionSelection(clickedOption, wrapper, variantsData, cartItems) {
  console.log('Handling option selection:', clickedOption.dataset.value);
  
  const optionIndex = clickedOption.dataset.optionIndex;
  const value = clickedOption.dataset.value;
  
  // Update selection UI within the same option group
  const optionGroup = clickedOption.closest('.option_group');
  if (optionGroup) {
    optionGroup.querySelectorAll('.option_value').forEach(el => {
      el.classList.remove('selected');
      el.style.transform = '';
      el.style.boxShadow = '';
    });
  }
  
  // Add selected class to clicked option
  clickedOption.classList.add('selected');
  clickedOption.style.transform = 'translateY(-1px)';
  clickedOption.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
  
  // Build current selection state
  const selectedOptions = {};
  wrapper.querySelectorAll('.option_value.selected').forEach(selected => {
    selectedOptions[selected.dataset.optionIndex] = selected.dataset.value;
  });
  
  console.log('Selected options:', selectedOptions);
  
  // Find matching variant
  const matchingVariant = findBestMatchingVariant(variantsData, selectedOptions, cartItems);
  console.log('Matching variant:', matchingVariant);
  
  if (matchingVariant) {
    // Update all selections to match the found variant
    const variantOptions = buildSelectedOptions(matchingVariant);
    updateSelectedOptions(wrapper, variantOptions);
    
    // Update price and button
    updatePrice(wrapper.querySelector('.price_wrapper'), matchingVariant);
    updateAddToCartButton(wrapper.querySelector('.add-to-cart'), matchingVariant, cartItems);
  } else {
    // No suitable variant found
    const addToCartBtn = wrapper.querySelector('.add-to-cart');
    if (addToCartBtn) {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Unavailable';
    }
  }
}

function findBestMatchingVariant(variants, selectedOptions, cartItems) {
  // Filter available variants not in cart
  const availableVariants = variants.filter(v => v.available && !cartItems.includes(v.id));
  
  if (availableVariants.length === 0) return null;
  
  // Try exact match first
  let exactMatch = availableVariants.find(variant => {
    return Object.keys(selectedOptions).every(optionIndex => {
      const selectedValue = selectedOptions[optionIndex];
      const variantValue = getVariantOptionValue(variant, optionIndex);
      return !selectedValue || variantValue === selectedValue;
    });
  });
  
  if (exactMatch) return exactMatch;
  
  // Try partial match (prioritize first option)
  let partialMatch = availableVariants.find(variant => {
    const firstOption = selectedOptions['1'];
    return !firstOption || getVariantOptionValue(variant, '1') === firstOption;
  });
  
  if (partialMatch) return partialMatch;
  
  // Return first available variant
  return availableVariants[0];
}

function getVariantOptionValue(variant, optionIndex) {
  switch (optionIndex) {
    case '1': return variant.option1;
    case '2': return variant.option2;
    case '3': return variant.option3;
    default: return null;
  }
}

function updateSelectedOptions(wrapper, selectedOptions) {
  // Clear all selections
  wrapper.querySelectorAll('.option_value').forEach(el => {
    el.classList.remove('selected');
    if (!el.matches(':hover')) {
      el.style.transform = '';
      el.style.boxShadow = '';
    }
  });
  
  // Apply new selections
  Object.keys(selectedOptions).forEach(optionIndex => {
    const value = selectedOptions[optionIndex];
    if (value) {
      const optionEl = wrapper.querySelector(`[data-option-index="${optionIndex}"][data-value="${value}"]`);
      if (optionEl) {
        optionEl.classList.add('selected');
        optionEl.style.transform = 'translateY(-1px)';
        optionEl.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
      }
    }
  });
}

function updateAddToCartButton(button, variant, cartItems) {
  if (!button || !variant) {
    if (button) {
      button.disabled = true;
      button.textContent = 'Unavailable';
      button.removeAttribute('data-crossellid');
    }
    return;
  }
  
  button.dataset.crossellid = variant.id;
  
  if (cartItems.includes(variant.id)) {
    button.disabled = true;
    button.textContent = 'In Cart';
    button.classList.add('in-cart');
  } else if (!variant.available) {
    button.disabled = true;
    button.textContent = 'Sold Out';
    button.classList.remove('in-cart');
  } else {
    button.disabled = false;
    button.textContent = 'Add To Cart';
    button.classList.remove('in-cart');
  }
}

function updatePrice(priceWrapper, variant) {
  if (!priceWrapper || !variant) return;
  
  const comparePrice = priceWrapper.querySelector('.comapre_price');
  const salePrice = priceWrapper.querySelector('.sale_price');
  const discountPercentage = priceWrapper.querySelector('.discount_percentage');
  
  // Update sale price
  if (salePrice) {
    salePrice.textContent = formatMoney(variant.price);
  }
  
  // Handle compare at price and discount
  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    if (comparePrice) {
      comparePrice.textContent = formatMoney(variant.compare_at_price);
      comparePrice.style.display = 'inline';
    }
    
    if (discountPercentage) {
      const discount = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
      discountPercentage.textContent = `(${discount}% OFF)`;
      discountPercentage.style.display = 'inline';
    }
  } else {
    if (comparePrice) comparePrice.style.display = 'none';
    if (discountPercentage) discountPercentage.style.display = 'none';
  }
}

function handleAddToCart(button, cartItems) {
  const variantId = button.dataset.crossellid;
  if (!variantId || button.disabled) return;
  
  const numericVariantId = parseInt(variantId);
  
  // Check if already in cart
  if (cartItems.includes(numericVariantId)) {
    button.textContent = 'Already in Cart';
    return;
  }
  
  // Show loading state
  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = 'Adding...';
  button.classList.add('loading');
  
  // Prepare request data
  const requestData = {
    id: numericVariantId,
    quantity: 1
  };
  
  console.log('Adding to cart:', requestData);
  
  // Make the request
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(requestData)
  })
  .then(response => {
    if (!response.ok) {
      return response.text().then(text => {
        throw new Error(`HTTP ${response.status}: ${text}`);
      });
    }
    return response.json();
  })
  .then(data => {
    console.log('Successfully added to cart:', data);
    
    // Update success state
    button.textContent = 'Added!';
    button.classList.remove('loading');
    button.classList.add('success');
    
    // Add to cart items array
    cartItems.push(numericVariantId);
    
    // Refresh cart
    refreshCartDrawer();
    
    // Update button to final state
    setTimeout(() => {
      button.textContent = 'In Cart';
      button.classList.remove('success');
      button.classList.add('in-cart');
    }, 1500);
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    
    // Reset button state
    button.disabled = false;
    button.textContent = originalText;
    button.classList.remove('loading');
    
    // Show error feedback
    button.textContent = 'Try Again';
    button.classList.add('error');
    
    setTimeout(() => {
      button.textContent = originalText;
      button.classList.remove('error');
    }, 2000);
    
    // Show user-friendly error message
    showErrorMessage('Sorry, there was an error adding this item to your cart. Please try again.');
  });
}

function refreshCartDrawer() {
  // Try to refresh cart using existing Shopify cart functionality
  if (typeof window.refreshCart === 'function') {
    window.refreshCart();
    return;
  }
  
  // Try cart drawer refresh
  if (window.cartDrawer && typeof window.cartDrawer.refresh === 'function') {
    window.cartDrawer.refresh();
    return;
  }
  
  // Try to trigger cart update event
  const cartUpdateEvent = new CustomEvent('cart:updated');
  document.dispatchEvent(cartUpdateEvent);
  
  // Fallback: fetch and update cart content
  fetch('/cart?view=drawer')
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newCartContent = doc.querySelector('#CartDrawer-CartItems');
      const newFooter = doc.querySelector('.drawer__footer');
      
      if (newCartContent) {
        const currentCartContent = document.querySelector('#CartDrawer-CartItems');
        if (currentCartContent) {
          currentCartContent.innerHTML = newCartContent.innerHTML;
        }
      }
      
      if (newFooter) {
        const currentFooter = document.querySelector('.drawer__footer');
        if (currentFooter) {
          currentFooter.innerHTML = newFooter.innerHTML;
        }
      }
      
      // Update cart count
      updateCartCount();
      
      // Re-initialize cross-sell after refresh
      setTimeout(() => {
        initializeCrossSellFunctionality();
      }, 100);
    })
    .catch(error => {
      console.error('Error refreshing cart:', error);
      // As fallback, reload the page after a short delay
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    });
}

function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Update cart count elements
      const cartCountElements = document.querySelectorAll('[data-cart-count]');
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
      });
      
      // Update cart total elements
      const cartTotalElements = document.querySelectorAll('[data-cart-total]');
      cartTotalElements.forEach(element => {
        element.textContent = formatMoney(cart.total_price);
      });
      
      // Update cart badge/indicator
      const cartBadges = document.querySelectorAll('.cart-count-bubble');
      cartBadges.forEach(badge => {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'block' : 'none';
      });
    })
    .catch(error => {
      console.error('Error updating cart count:', error);
    });
}

// Fast formatMoney function with ₹ symbol
function formatMoney(cents) {
  if (!cents || isNaN(cents)) return '₹0';
  const numericCents = typeof cents === 'string' ? parseFloat(cents) : cents;
  if (isNaN(numericCents)) return '₹0';
  const amount = Math.round(numericCents / 100);
  return `₹${amount}`;
}

function showErrorMessage(message) {
  // Create or show error notification
  let errorNotification = document.querySelector('.crosssell-error-notification');
  
  if (!errorNotification) {
    errorNotification = document.createElement('div');
    errorNotification.className = 'crosssell-error-notification';
    errorNotification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #dc2626;
      color: white;
      padding: 1rem;
      border-radius: 4px;
      z-index: 9999;
      max-width: 300px;
      font-size: 0.875rem;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      transform: translateX(100%);
      transition: transform 0.3s ease;
    `;
    document.body.appendChild(errorNotification);
  }
  
  errorNotification.textContent = message;
  errorNotification.style.transform = 'translateX(0)';
  
  // Hide after 4 seconds
  setTimeout(() => {
    errorNotification.style.transform = 'translateX(100%)';
  }, 4000);
}

// Additional CSS for better interaction
const additionalStyles = `
  .option_value {
    position: relative;
    transition: all 0.2s ease;
    user-select: none;
    pointer-events: auto !important;
    cursor: pointer !important;
  }
  
  .option_value:hover {
      background: #CF2930 !important;
border:none;
    transform: translateY(-1px) !important;
  }
  
  .option_value.selected {
    border:1px solid #CF2930 !important;
    background: #fff !important;
    color: #000000 !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1) !important;
  }
  
  .option_group.color .option_value.selected::after {
    content: '✓';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 12px;
    font-weight: bold;
    text-shadow: 0 0 2px rgba(0,0,0,0.5);
  }
  
  .add-to-cart:disabled {
    opacity: 0.6;
    cursor: not-allowed !important;
  }
  
  .add-to-cart:not(:disabled):hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  }
  
  .add-to-cart.loading {
    position: relative;
  }
  
  .add-to-cart.loading::after {
    content: '';
    position: absolute;
    top: 50%;
    right: 8px;
    width: 12px;
    height: 12px;
    margin-top: -6px;
    border: 2px solid transparent;
    border-top: 2px solid white;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  .add-to-cart.success {
    background: #059669 !important;
    color: white !important;
  }
  
  .add-to-cart.error {
    background: #dc2626 !important;
    color: white !important;
  }
  
  .add-to-cart.in-cart {
    background: #6b7280 !important;
    cursor: default !important;
  }
  
  .crossell-item-wrapper {
    position: relative;
  }
  
  
  /* Ensure proper z-index for interactive elements */
  .option_value,
  .add-to-cart {
    position: relative;
    z-index: 1;
  }
  
  /* Force ₹ symbol styling */
  .price_wrapper .sale_price,
  .price_wrapper .comapre_price {
    font-family: inherit !important;
  }
  
  .price_wrapper .sale_price::before,
  .price_wrapper .comapre_price::before {
    content: '' !important;
  }
`;

// Inject additional styles
if (!document.querySelector('#crosssell-additional-styles')) {
  const styleSheet = document.createElement('style');
  styleSheet.id = 'crosssell-additional-styles';
  styleSheet.textContent = additionalStyles;
  document.head.appendChild(styleSheet);
}